import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function BackdropSpinner({ open = false }) {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: 10000 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
